import React, { useEffect } from 'react';
import { Layout } from '@/components/Layout';
import { Card } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const AllStates = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const states = [
    { name: 'Alabama', path: '/alabama' },
    { name: 'Alaska', path: '/alaska' },
    { name: 'Arizona', path: '/arizona' },
    { name: 'Arkansas', path: '/arkansas' },
    { name: 'California', path: '/california' },
    { name: 'Colorado', path: '/colorado' },
    { name: 'Connecticut', path: '/connecticut' },
    { name: 'Delaware', path: '/delaware' },
    { name: 'District of Columbia', path: '/district-of-columbia' },
    { name: 'Florida', path: '/florida' },
    { name: 'Georgia', path: '/georgia' },
    { name: 'Hawaii', path: '/hawaii' },
    { name: 'Idaho', path: '/idaho' },
    { name: 'Illinois', path: '/illinois' },
    { name: 'Indiana', path: '/indiana' },
    { name: 'Iowa', path: '/iowa' },
    { name: 'Kansas', path: '/kansas' },
    { name: 'Kentucky', path: '/kentucky' },
    { name: 'Louisiana', path: '/louisiana' },
    { name: 'Maine', path: '/maine' },
    { name: 'Maryland', path: '/maryland' },
    { name: 'Massachusetts', path: '/massachusetts' },
    { name: 'Michigan', path: '/michigan' },
    { name: 'Minnesota', path: '/minnesota' },
    { name: 'Mississippi', path: '/mississippi' },
    { name: 'Missouri', path: '/missouri' },
    { name: 'Montana', path: '/montana' },
    { name: 'Nebraska', path: '/nebraska' },
    { name: 'Nevada', path: '/nevada' },
    { name: 'New Hampshire', path: '/new-hampshire' },
    { name: 'New Jersey', path: '/new-jersey' },
    { name: 'New Mexico', path: '/new-mexico' },
    { name: 'New York', path: '/new-york' },
    { name: 'North Carolina', path: '/north-carolina' },
    { name: 'North Dakota', path: '/north-dakota' },
    { name: 'Ohio', path: '/ohio' },
    { name: 'Oklahoma', path: '/oklahoma' },
    { name: 'Oregon', path: '/oregon' },
    { name: 'Pennsylvania', path: '/pennsylvania' },
    { name: 'Rhode Island', path: '/rhode-island' },
    { name: 'South Carolina', path: '/south-carolina' },
    { name: 'South Dakota', path: '/south-dakota' },
    { name: 'Tennessee', path: '/tennessee' },
    { name: 'Texas', path: '/texas' },
    { name: 'Utah', path: '/utah' },
    { name: 'Vermont', path: '/vermont' },
    { name: 'Virginia', path: '/virginia' },
    { name: 'Washington', path: '/washington' },
    { name: 'West Virginia', path: '/west-virginia' },
    { name: 'Wisconsin', path: '/wisconsin' },
    { name: 'Wyoming', path: '/wyoming' },
  ];

  React.useEffect(() => {
    document.title = 'Property Tax Appeal Procedures by State | PropertyTaxHero';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Complete guide to property tax appeal procedures, deadlines, and requirements for all 50 states. Find your state\'s specific assessment appeal process.');
    }
  }, []);

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-tax-backgroundLight to-white">
        <div className="container mx-auto px-4 py-8 max-w-6xl">
          {/* Hero Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-tax-deepBlue mb-6">
              Property Tax Appeals by State
            </h1>
            <p className="text-xl text-tax-neutralGray max-w-3xl mx-auto leading-relaxed">
              Find detailed property tax appeal procedures, deadlines, and requirements for your state
            </p>
          </div>

          {/* States Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {states.map((state) => (
              <Card key={state.path} className="p-6 hover:shadow-lg transition-shadow">
                <Link 
                  to={state.path}
                  className="group flex items-center justify-between"
                >
                  <div>
                    <h3 className="text-lg font-semibold text-tax-deepBlue group-hover:text-tax-brightBlue transition-colors">
                      {state.name}
                    </h3>
                    <p className="text-sm text-tax-neutralGray mt-1">
                      View appeal procedures & deadlines
                    </p>
                  </div>
                  <ArrowRight className="h-5 w-5 text-tax-neutralGray group-hover:text-tax-brightBlue transition-colors" />
                </Link>
              </Card>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="text-center">
            <Card className="p-8 bg-tax-backgroundLight">
              <h3 className="text-2xl font-bold text-tax-deepBlue mb-4">
                Need Help with Your Property Tax Appeal?
              </h3>
              <p className="text-lg text-tax-neutralGray mb-6">
                Get personalized guidance and deadline reminders for your specific property
              </p>
              <Link to="/">
                <button className="bg-tax-deepBlue hover:bg-tax-brightBlue text-white px-8 py-3 rounded-xl font-semibold transition-colors">
                  Start Your Free Assessment
                  <ArrowRight className="ml-2 h-4 w-4 inline" />
                </button>
              </Link>
            </Card>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AllStates;